import { Inject, Injectable } from '@angular/core';
import * as models from '../../models';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import * as apiStatusContracts from './contracts';
import * as coreTypes from '../../../core/types';

@Injectable()
export class ApiStatusService implements apiStatusContracts.IApiStatusService {
  apiEnum = models.ApiEnum;

  constructor(
    private http: HttpClient,
    @Inject(coreTypes.SERVICE_TOKEN) private configService: coreTypes.IConfigService
  ) {}

  getApiStatus(request: string): Observable<models.ApiStatus> {
    let requestUrl = '';
    switch(request) {
      case this.apiEnum.OPERATOR_API: {
        requestUrl = `${this.configService.get(coreTypes.ConfigKeysEnum.OPERATOR_API_ENDPOINT)}/status`;
        break;
      }
      case this.apiEnum.AIRCRAFT_API: {
        requestUrl = `${this.configService.get(coreTypes.ConfigKeysEnum.AIRCRAFT_SERVICE_ENDPOINT)}/status`;
        break;
      }
      case this.apiEnum.SOURCING_API: {
        requestUrl = `${this.configService.get(coreTypes.ConfigKeysEnum.SOURCING_SERVICE_ENDPOINT)}/status`;
        break;
      }
      default: {
        return of(null);
      }
    }
    return this.http.get<any>(requestUrl).pipe(
      map(serviceResponse => {
        const apiStatus = new models.ApiStatus();
        const {['xo-libraries']: xoLibraries, ...status} = serviceResponse;
        apiStatus.xoLibraries = xoLibraries;
        apiStatus.status = status;
        return apiStatus;
      })
    );
  }
}
